export const DASHBOARD = {
    KPI: {
        BACKGROUND_COLOR: '#ECF2F5',
        RADIALBAR: {
            BACKGROUND_COLOR: '#F1F1F1',
            FILL_COLOR: '#FFAB00',
        },
        SURVEYCOMPLETEDRADIALBAR: {
            BACKGROUND_COLOR: '#D8D9DA',
            FILL_COLOR: '#F15A2C',
        },
        SURVEYEMAILSSENTRADIALBAR: {
            BACKGROUND_COLOR: '#D8D9DA',
            FILL_COLOR: '#A1DDF3',
        },
    },
    LINE_CHART: {
        STROKE_COLOR: '#4A6447',
        FILL_COLOR: '#4E7780',
    },
    BAR_CHART: {
        FILL_COLOR: '#4C81AF',
    },
    SURVEY_RESULT: {
        BACKGROUND_COLOR: '#FFFFFF',
        HOVER_COLOR: '#F2F2F2',
        SELECTED_TEXT_COLOR: '#494949',
    },
};
